import { appConfig } from './appConfig'
import { roadwayVariables, modalTiers } from './generalInputs.config'
import { pedestrianConfig } from './pedestrianConfig'
import { bicycleConfig } from './bicycleConfig'
import { autoConfig } from './autoConfig'
import { freightConfig } from './freightConfig'
import { themeConfig } from './theme.config'
import { transitConfig } from './transitConfig'
import { counterMeasuresConfig } from './counterMeasuresConfig'
const config = {
  appConfig,
  roadwayVariables,
  modalTiers,
  themeConfig,
  pedestrianConfig,
  bicycleConfig,
  autoConfig,
  freightConfig,
  transitConfig,
  counterMeasuresConfig
}

export default config
